<mat-drawer-container class="app-shell">
  <mat-drawer mode="side" opened class="app-sidenav">
    <div class="sidenav-header">Lagesio</div>
    <mat-divider></mat-divider>

    <mat-nav-list>
      <a mat-list-item routerLink="/app/overview" routerLinkActive="active-link">
        <mat-icon matListItemIcon>dashboard</mat-icon>
        <span matListItemTitle>{{ 'nav.overview' | translate }}</span>
      </a>

      <a mat-list-item routerLink="/app/dashboards" routerLinkActive="active-link">
        <mat-icon matListItemIcon>space_dashboard</mat-icon>
        <span matListItemTitle>{{ 'nav.dashboards' | translate }}</span>
      </a>

      <a mat-list-item routerLink="/app/queries" routerLinkActive="active-link">
        <mat-icon matListItemIcon>query_stats</mat-icon>
        <span matListItemTitle>{{ 'nav.queries' | translate }}</span>
      </a>

      <a mat-list-item routerLink="/app/data-sources" routerLinkActive="active-link">
        <mat-icon matListItemIcon>storage</mat-icon>
        <span matListItemTitle>{{ 'nav.dataSources' | translate }}</span>
      </a>

      <a mat-list-item routerLink="/app/schedules" routerLinkActive="active-link">
        <mat-icon matListItemIcon>schedule</mat-icon>
        <span matListItemTitle>{{ 'nav.schedules' | translate }}</span>
      </a>

      <a mat-list-item routerLink="/app/alerts" routerLinkActive="active-link">
        <mat-icon matListItemIcon>notification_important</mat-icon>
        <span matListItemTitle>{{ 'nav.alerts' | translate }}</span>
      </a>

      <a mat-list-item routerLink="/app/webhooks" routerLinkActive="active-link">
        <mat-icon matListItemIcon>sync_alt</mat-icon>
        <span matListItemTitle>{{ 'nav.webhooks' | translate }}</span>
      </a>

      <a mat-list-item routerLink="/app/audit" routerLinkActive="active-link">
        <mat-icon matListItemIcon>history</mat-icon>
        <span matListItemTitle>{{ 'nav.audit' | translate }}</span>
      </a>

      <mat-divider></mat-divider>

      <a mat-list-item routerLink="/app/settings" routerLinkActive="active-link">
        <mat-icon matListItemIcon>tune</mat-icon>
        <span matListItemTitle>{{ 'nav.settings' | translate }}</span>
      </a>
    </mat-nav-list>
  </mat-drawer>

  <mat-drawer-content>
    <mat-toolbar color="primary">

      <!-- Org title + switch org (only if >1) -->
      <div class="org-area">
        <span class="org-title">{{ user.getSelectedOrganization()?.name ?? ('toolbar.orgSelected' | translate) }}</span>

        <button
          *ngIf="this.user.getOrganizations().length > 1"
          mat-button
          class="org-switch-btn"
          [matMenuTriggerFor]="orgMenu"
          aria-label="Switch organization"
        >
          <mat-icon>apartment</mat-icon>
          {{ 'toolbar.change' | translate }}
          <mat-icon>expand_more</mat-icon>
        </button>

        <mat-menu #orgMenu="matMenu">
          <button
            mat-menu-item
            *ngFor="let org of this.user.getOrganizations()"
            (click)="switchOrganization(org)"
            [disabled]="org.id === this.user.getSelectedOrganizationId()"
          >
            <mat-icon>{{ org.id === this.user.getSelectedOrganizationId() ? 'check' : 'domain' }}</mat-icon>
            <span>{{ org.name }}</span>
          </button>
        </mat-menu>
      </div>

      <span class="spacer"></span>

      <!-- Language menu -->
      <button mat-button class="lang-btn" [matMenuTriggerFor]="langMenu" aria-label="Change language">
        <mat-icon>language</mat-icon>
        {{ currentLang.toUpperCase() }}
        <mat-icon>expand_more</mat-icon>
      </button>

      <mat-menu #langMenu="matMenu">
        <button mat-menu-item (click)="setLang('en')" [disabled]="currentLang === 'en'">
          <span>English</span>
          <span class="menu-spacer"></span>
          <mat-icon *ngIf="currentLang === 'en'">check</mat-icon>
        </button>
        <button mat-menu-item (click)="setLang('ro')" [disabled]="currentLang === 'ro'">
          <span>Română</span>
          <span class="menu-spacer"></span>
          <mat-icon *ngIf="currentLang === 'ro'">check</mat-icon>
        </button>
      </mat-menu>

      <!-- User menu -->
      <button mat-button [matMenuTriggerFor]="userMenu" aria-label="User menu">
        <mat-icon>account_circle</mat-icon>
        {{ user.getUserName() }}
        <mat-icon>expand_more</mat-icon>
      </button>

      <mat-menu #userMenu="matMenu">
        <button mat-menu-item routerLink="/app/settings">
          <mat-icon>settings</mat-icon>
          {{ 'nav.settings' | translate }}
        </button>

        <mat-divider></mat-divider>

        <button mat-menu-item (click)="logout()">
          <mat-icon>logout</mat-icon>
          {{ 'toolbar.signOut' | translate }}
        </button>
      </mat-menu>
    </mat-toolbar>

    <main class="app-main">
      
      @if (loading) {
        <mat-progress-spinner
          mode="indeterminate"
          diameter="20">
        </mat-progress-spinner>
      }
      @else {
        <router-outlet></router-outlet>
      }
    </main>
  </mat-drawer-content>
</mat-drawer-container>
